module.exports = __webpack_public_path__ + "img/xtts.0455bbf5.svg";